// This file is required to use @next/mdx in the `app` directory.
export function useMDXComponents(components) {
    return {
      h1: ({ children }) => <h1 style={{ fontSize: "100px" }}>{children}</h1>,
      button: (params) => <Button {...params} />,
      ...components,
    }
  }